export interface FeatureFlagModuleState {
  flags?: Record<string, boolean>
}

export const state: FeatureFlagModuleState = {
  flags: undefined
}
